import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useRef } from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';

const useStyles = makeStyles({
  modal: { minWidth: '45%' },
});

let countDownInterval;

export const TimeoutWarningModal = ({ onRequestExtendSession, handleLogout }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const { isMobileDevice } = useWindowDimensions();

  const timeoutWarningMsg = translateString('sessionTimeoutWarningMessage').split('{0}');

  const countdownRef = useRef();

  // Use useEffect() to update the DOM countdown timer directly
  useEffect(() => {
    countDownInterval = setInterval(() => {
      const countdownElement = countdownRef.current;

      // Calculate the remaining time
      const currentTime = new Date().getTime();
      const tokenExpirationTime = new Date(localStorage.getItem('sessionTimeoutDate')).getTime();

      const remainingTime = new Date(tokenExpirationTime - currentTime);

      // Check if the countdown is finished
      if (remainingTime <= 0) {
        handleLogout('auto');
        clearInterval(countDownInterval);
        return;
      }

      // Format the remaining time
      const seconds = Math.floor((remainingTime / 1000) % 60);
      const minutes = Math.floor((remainingTime / 1000 / 60) % 60);

      //Update the DOM directly
      if (countdownElement) {
        countdownElement.innerText = ` ${minutes} ${timeoutWarningMsg[1].replace('{1}', seconds)}`;
      }
    }, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(countDownInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      disableBackdropClick
      open
      className={classes.modal}
      variant="error"
      title={translateString('Session Timeout')}
      buttonProps={[
        { label: translateString('Log Off'), onClick: handleLogout },
        {
          label: translateString('Stay Logged In'),
          onClick: () => onRequestExtendSession(new Date()),
        },
      ]}
      PaperProps={{ style: { margin: isMobileDevice ? 16 : 32 } }}
      ui-ta="SessionTimeoutWarning"
    >
      {timeoutWarningMsg[0]}
      <span ref={countdownRef} />
    </Modal>
  );
};
